export enum BulkProductUploadReportCsvColumns {
  ROW_NUMBER = "ROW_NUMBER",
  STATUS = "STATUS",
  MERCHANT_SKU = "MERCHANT_SKU",
  DSKU = "DSKU",
  UNITS_PER_BOX = "UNITS_PER_BOX",
  NUMBER_OF_BOXES = "NUMBER_OF_BOXES",
  TOTAL_UNITS = "TOTAL_UNITS",
  LOT_NUMBER = "LOT_NUMBER",
  ERROR_MESSAGE = "ERROR_MESSAGE",
  ERROR_CODE = "ERROR_CODE",
}
